import {AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import {NgModel} from '@angular/forms';
import {NgbDatepicker, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';

@Directive({
  selector: 'input[ngModel][ngbDatepicker][appMinDate], input[ngModel][ngbDatepicker][appMaxDate]',
  // providers: [NgModel, NgbDatepicker]
})
export class DateMinMaxValidationDirective implements OnInit, AfterViewInit {
  private minDate: Date = null;
  private maxDate: Date = null;

  constructor(private elem: ElementRef) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  @Input('appMinDate') set appMinDate(date: NgbDateStruct) {
    if (date !== null && date !== undefined) {
      this.minDate = new Date(date.year, date.month - 1, date.day);
      this.validateAppDate(this.elem.nativeElement);
    }
  }

  @Input('appMaxDate') set appMaxDate(date: NgbDateStruct) {
    if (date !== null && date !== undefined) {
      this.maxDate = new Date(date.year, date.month - 1, date.day);
      this.validateAppDate(this.elem.nativeElement);
    }
  }

  @HostListener('blur', ['$event.target'])
  onBlur(elem) {
    this.validateAppDate(elem);
  }

  validateAppDate(elem) {
    // let elem: any = this || event;
    if (elem.inputmask) {
      const dateStr = elem.inputmask.unmaskedvalue();
      const errorMsgID = elem.id + '_errorMsgAppInvalidDt';

    if (!elem.inputmask.isComplete() || dateStr === '' ) {
      return;
    }

    /*if($("[id*='_errorMsg']:visible").length > 0) {
      if($("[id*='_errorMsgAppInvalidDt']:visible").length === 0) {
        return;
      }
    }*/

    $('#' + errorMsgID).remove();
    elem.classList.remove("ng-invalid");
    elem.classList.add("ng-valid");

    const month = parseInt(dateStr.substring(0,2), 10);
    const day = parseInt(dateStr.substring(2,4), 10);
    const year = parseInt(dateStr.substring(4), 10);
    const date = new Date(year, month - 1, day);
    let minDateStr = '';
    let maxDateStr = '';

    if(this.minDate !== null && this.minDate !== undefined) {
      minDateStr = (this.minDate.getMonth() + 1) + '/' + this.minDate.getDate() + '/' + this.minDate.getFullYear();
    }

    if(this.maxDate !== null && this.maxDate !== undefined) {
      maxDateStr = (this.maxDate.getMonth() + 1) + '/' + this.maxDate.getDate() + '/' + this.maxDate.getFullYear();
    }

    if (this.minDate !== null && this.minDate !== undefined
        && this.maxDate !== null && this.maxDate !== undefined) {
      if (date < this.minDate || date > this.maxDate) {
        const errorMsg = 'Date should be between ' + minDateStr + ' and ' + maxDateStr;
        elem.classList.remove("ng-valid");
        elem.classList.add("ng-invalid");
        $(elem).parent().parent(":not(:has([id*='_errorMsg']))").append("<div id='" + errorMsgID + "' role='alert'><small class='form-text text-danger'>"+errorMsg+"</small></div>");
      }
    } else if (this.minDate !== null && this.minDate !== undefined) {
      if (date < this.minDate) {
        const errorMsgLessThan = 'Date can not be lesser than ' + minDateStr;
        elem.classList.remove("ng-valid");
        elem.classList.add("ng-invalid");
        $(elem).parent().parent(":not(:has([id*='_errorMsg']))").append("<div id='" + errorMsgID + "' role='alert'><small class='form-text text-danger'>"+errorMsgLessThan+"</small></div>");
      }
    } else if (this.maxDate !== null && this.maxDate !== undefined) {
      if (date > this.maxDate) {
        const errorMsgGreaterThan = 'Date can not be greater than ' + maxDateStr;
        elem.classList.remove("ng-valid");
        elem.classList.add("ng-invalid");
        $(elem).parent().parent(":not(:has([id*='_errorMsg']))").append("<div id='" + errorMsgID + "' role='alert'><small class='form-text text-danger'>"+errorMsgGreaterThan+"</small></div>");
      }
    }

    return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/dateMinMaxValidation.directive.ts